export const RoutesMap = {
  // Splash
  SPLASH: '/',

  // Role selection (public, no auth check)
  SELECT_ROLE: '/select-role',
  BARBER_TYPE: '/barber-type',

  // Owner routes (public - redirect to dashboard if logged in)
  OWNER_LOGIN: '/owner/login',
  OWNER_REGISTER: '/owner/register',
  OWNER_FORGOT_PASSWORD: '/owner/forgot-password',

  // Team Member routes (public - redirect to dashboard if logged in)
  TEAM_MEMBER_LOGIN: '/team-member/login',
  TEAM_MEMBER_CREATE_PASSWORD: '/team-member/create-password',
  TEAM_MEMBER_FORGOT_PASSWORD: '/team-member/forgot-password',

  // Customer routes (public)
  CUSTOMER_REGISTER: '/customer/register',
  CUSTOMER_LOGIN: '/customer/login',
  CUSTOMER_FORGOT_PASSWORD: '/customer/forgot-password',

  // Customer routes (private)
  CUSTOMER_HOME: '/customer/home',
  CUSTOMER_BARBER_PROFILE: '/customer/barber/:barberId',
  CUSTOMER_BARBER_BOOK: '/customer/barber/:barberId/book',
  CUSTOMER_APPOINTMENTS: '/customer/appointments',
  CUSTOMER_BOOKING_CONFIRM: '/customer/booking/confirm',
  CUSTOMER_BARBER_RANK: '/customer/barber-rank',
  CUSTOMER_BARBERSHOPS_RANKS: '/customer/barbershops-ranks',
  CUSTOMER_FAVOURITES: '/customer/favourites',
  CUSTOMER_SHOP_BARBERS: '/customer/shop/:shopId',
  CUSTOMER_MESSAGES: '/customer/messages',
  CUSTOMER_PROFILE: '/customer/profile',
  CUSTOMER_ABOUT_US: '/customer/about-us',
  CUSTOMER_CONTACT_US: '/customer/contact-us',

  // Legacy aliases (keep for backward compat)
  AUTH: '/owner/login',
  LOGIN: '/owner/login',
  REGISTER: '/owner/register',
  FORGOT_PASSWORD: '/owner/forgot-password',

  // Private routes (authenticated)
  DASHBOARD: '/dashboard',
  APPOINTMENTS: '/appointments',
  EARNINGS: '/earnings',
  CHAMPIONSHIP: '/championship',
  EMPLOYEE_BARBERS_RANKING: '/employee/barbers-ranking',
  TARGETS: '/targets',
  NEWS: '/news',
  ABOUT_US: '/about-us',
  CONTACT_US: '/contact-us',
  YOUR_TEAM: '/your-team',
  ADD_MEMBER: '/your-team/add-member',
  SETTINGS: '/settings',
  PROFILE: '/profile',
  ANALYTICS: '/analytics',
  RATINGS: '/ratings',
  MESSAGES: '/messages',
  SHOP_SCHEDULE: '/shop-schedule',

  // Public barber booking page (no auth required)
  PUBLIC_BARBER: '/b/:slug/:employeeId',

  // Pay later post-payment pages
  PAYMENT_CANCELLED: '/payment-cancelled',

  // Legal
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_OF_SERVICE: '/terms-of-service',
} as const;
